export default "<app-ui-loading-indicator [status]=\"uiStatus\"></app-ui-loading-indicator>\r\n<h1>{{message}}</h1>\r\n"